import React, { PureComponent } from "react";
import PageLink from "../../../components/Page/PageLink";
import Footer from "../../../components/Footer/Footer";

class Layout_tab_menu extends PureComponent {
  render() {
    return (
      <div className="row" id="layout_tab_menu">
        <div className="col-md-6">
          <div className="contentLight">
            <section>
              <h2>Layout Tab Menu</h2>
              <p>
                The layout tab menu allows you to add a tab menu strip on the
                top of your dashboards, record pages and search pages. Giving
                you the flexibility to dynamically show and hide layout cells.
                When a user selects a tab menu option the
                NL.Interface.tabMenu.value property is set to the value of the
                tab option.
              </p>
              <p>
                In the cell section of your layout model add a hide_if_eval that
                tests for the menu option.
              </p>

              <div className="darkCode">
                "<span className="jsonG">hide_if_eval</span>": "
                <span className="jsonY">
                  (NL.Interface.tabMenu.value !== 'Overview')
                </span>
                "
              </div>

              <h3>Compatibility</h3>
              <table style={{ width: "auto" }}>
                <tbody>
                  <tr>
                    <td className="b top">Page</td>
                    <td className="b top">Support</td>
                  </tr>
                  <tr>
                    <td className="b" style={{ paddingTop: 4 }}>
                      Dashboard
                    </td>
                    <td style={{ textAlign: "center" }}>
                      <i
                        className="material-icons"
                        style={{
                          position: "relative",
                          top: 3,
                          fontSize: 24,
                          color: "#388E3C",
                          fontWeight: "bold",
                        }}
                      >
                        done
                      </i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b" style={{ paddingTop: 4 }}>
                      Record
                    </td>
                    <td style={{ textAlign: "center" }}>
                      <i
                        className="material-icons"
                        style={{
                          position: "relative",
                          top: 3,
                          fontSize: 24,
                          color: "#388E3C",
                          fontWeight: "bold",
                        }}
                      >
                        done
                      </i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b" style={{ paddingTop: 4 }}>
                      Report
                    </td>
                    <td style={{ textAlign: "center" }}>
                      <i
                        className="material-icons"
                        style={{
                          position: "relative",
                          top: 3,
                          fontSize: 24,
                          color: "#D32F2F",
                          fontWeight: "bold",
                        }}
                      >
                        close
                      </i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b" style={{ paddingTop: 4 }}>
                      Search
                    </td>
                    <td style={{ textAlign: "center" }}>
                      <i
                        className="material-icons"
                        style={{
                          position: "relative",
                          top: 3,
                          fontSize: 24,
                          color: "#388E3C",
                          fontWeight: "bold",
                        }}
                      >
                        done
                      </i>
                    </td>
                  </tr>
                </tbody>
              </table>
              <h3>Properties</h3>
              <table>
                <tbody>
                  <tr>
                    <td className="b top">Property</td>
                    <td className="b top">Description</td>
                  </tr>
                  <tr>
                    <td className="b">options</td>
                    <td>
                      Tab options definition (see below).
                      <br />
                      <i>{"{ ... }"}</i>
                    </td>
                  </tr>
                </tbody>
              </table>

              <h3>Options</h3>
              <table>
                <tbody>
                  <tr>
                    <td className="b top">Property</td>
                    <td className="b top">Description</td>
                  </tr>
                  <tr>
                    <td className="b">name</td>
                    <td>
                      Display name. <br />
                      <i>"My name" default ""</i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">order</td>
                    <td>
                      Order the tab menu options will be displayed.
                      <br />
                      <i>1 - 1000 default undefined</i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">value</td>
                    <td>
                      Value sent to NL.Interface.tabMenu.value on selection.
                      <br />
                      <i>"Home", "Notes" default ""</i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">color</td>
                    <td>
                      Color of the underline when tab option selected. <br />
                      <i>"#388E3C", "#D32F2F" default "rgba(0, 0, 0, 0.87)"</i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">selected</td>
                    <td>
                      Sets the default selectd option.
                      <br />
                      <i>true, false default false</i>
                    </td>
                  </tr>
                </tbody>
              </table>
              <Footer
                section={this.props.section}
                article={this.props.article}
                routeParams={this.props.routeParams}
              />
            </section>
          </div>
        </div>
        <div className="col-md-6 darkCol">
          <div className="contentDark">
            <section>
              <h2>Tab Menu Example</h2>
            </section>
            <section>
              <h3>Example:</h3>
              <div className="darkCode">
                <div>&#123;</div>
                <div className="i1">
                  <span className="jsonG">"options"</span>: &#123;
                </div>
                <div className="i2">
                  <span className="jsonG">"my_first_option"</span>: &#123;
                </div>
                <div className="i3">
                  <span className="jsonG">"name"</span>:{" "}
                  <span className="jsonY">"First Option"</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"order"</span>:{" "}
                  <span className="jsonP">1</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"value"</span>:{" "}
                  <span className="jsonY">"tab1"</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"color"</span>:{" "}
                  <span className="jsonY">"#388E3C"</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"selected"</span>:{" "}
                  <span className="jsonP">true</span>
                </div>
                <div className="i2">&#125;,</div>
                <div className="i2">
                  <span className="jsonG">"my_second_option"</span>: &#123;
                </div>
                <div className="i3">
                  <span className="jsonG">"name"</span>:{" "}
                  <span className="jsonY">"Second Option"</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"order"</span>:{" "}
                  <span className="jsonP">2</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"value"</span>:{" "}
                  <span className="jsonY">"tab2"</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"color"</span>:{" "}
                  <span className="jsonY">"#D32F2F"</span>
                </div>
                <div className="i2">&#125;</div>
                <div className="i1">&#125;</div>
                <div>&#125;</div>
              </div>
            </section>
          </div>
        </div>
      </div>
    );
  }
}

export default Layout_tab_menu;



// WEBPACK FOOTER //
// ./src/components/knowlege/interface/Layout_tab_menu.js